<div class="outer-container">
    <div class="img-container">
        <img src="./images/mpin.svg">
    </div>
    <div class="data-container">
        <div>{{'verifyMpin.verifyMpinDetails' | translate}}</div>
    </div>
    <form #ngForm (ngSubmit)="verifyMpin()">
        <div class="form-container">
            <ng-otp-input [config]="{length:6,allowNumbersOnly:true}" (onInputChange)="onOtpChange($event)">
            </ng-otp-input>
            <div class="display-b" (click)="forgetPinClick()">
                <p class="forgot-txt">{{ 'verifyMpin.ForgotMPIN' | translate }}</p>
            </div>
        </div>
        <div class="buttons-container">
            <button class="primary-button cursor-pointer" [disabled]="mpin?.length < 6">{{'verifyMpin.verify' | translate }}</button>
            
        </div>
    </form>
    <button class="secondary-button cursor-pointer" (click)="cancelClick($event)">{{ 'verifyMpin.cancel' | translate }}</button>

</div>